import React from 'react';

const HomeContainer = () => (
  <div>
    <h1>
      Welcome to Sample 3D Viewer, go to{' '}
      <a href="https://digitaltwin.cogniteapp.com">Digital Twin</a> to select a
      model to preview.
    </h1>
  </div>
);

export default HomeContainer;



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js